<script setup lang="ts">
import Times from '~icons/cue-regular/times'
import Backdrop from '../backdrop/Backdrop.vue'
import OldIconButton from '../oldIcons/OldIconButton.vue'

withDefaults(
  defineProps<{
    label?: string
    text?: string
    close?: boolean
    backdropVShow?: boolean
    compactBottom?: boolean
  }>(),
  {
    label: '',
    text: '',
    close: true,
    backdropVShow: false,
    compactBottom: false,
  },
)

defineSlots<{
  header?: () => void
  content?: () => void
}>()

const show = defineModel<boolean>('show', { default: false })
</script>

<template lang="pug">
  Backdrop(v-model:show="show" :useVShow="backdropVShow")
    .modal-dialog.h-100p.flex.col-0(:class="{ 'compact-bottom': compactBottom }")
      .header-container.x-paddings.typ-14-20-500.flex.col-4.p-t-20(:class="{ grey: $slots['header-bottom'] }")
        .header.flex-between-center
          .header-label
            slot(name="header")
              | {{ $t(label) }}
          OldIconButton.s-20(v-if="close" :name="Times" @click="show = false")
        .h-20

      .content-container.x-paddings.p-y-12.h-100p
        slot(name="content")
          | {{ text }}
</template>

<style scoped>
.modal-dialog {
  overflow: hidden;
  border: 1px solid var(--cue-border-neutral-primary);
  background: var(--cue-bg-surface-primary);
  box-shadow: 0 1px 20px 0 color-mix(in srgb, var(--cue-static-neutral-inverse) 20%, transparent);

  border-radius: 24px 24px 0 0;
  height: calc(100vh - 70px);
  @supports (height: 100dvh) {
    height: calc(100dvh - 70px);
  }
  margin-top: 70px;
  min-width: 320px;
  width: 100vw;
  @supports (width: 100dvw) {
    width: 100dvw;
  }
  max-width: 800px;

  @screen sm {
    height: calc(100vh - 100px);
    @supports (height: 100dvh) {
      height: calc(100dvh - 100px);
    }
    margin-top: 100px;
  }

  @screen md {
    --uno: br-24;
    height: unset;
    max-height: calc(100vh - 100px);
    @supports (max-height: 100dvh) {
      max-height: calc(100dvh - 100px);
    }
    margin-top: unset;
  }

  &.compact-bottom {
    height: auto;
    max-height: min(70vh, calc(100vh - 48px - env(safe-area-inset-bottom, 0px)));
    margin-top: auto;
    margin-bottom: calc(32px + env(safe-area-inset-bottom, 0px));
    border-radius: 24px;
    width: calc(100vw - 32px);

    @supports (max-height: 100dvh) {
      max-height: min(70dvh, calc(100dvh - 48px - env(safe-area-inset-bottom, 0px)));
    }

    @supports (width: 100dvw) {
      width: calc(100dvw - 32px);
    }

    @screen md {
      height: auto;
      margin-top: auto;
    }
  }
}

.header-container {
  background: var(--cue-bg-neutral-primary-hover);
}

.header-label {
  color: var(--cue-content-neutral-primary);
}

.x-paddings {
  --uno: p-x-16;

  @screen md {
    --uno: p-x-24;
  }
}

.content-container {
  --uno: min-h-0;
  overflow: auto;
}
</style>
